export default {
    appTitle: "ALLU",
    common: {
        ok: "OK",
        remove: "Remove",
        view: "View",
        cancel: "Cancel",
        rename: "Rename",
        copyright: "Copyright 2018 ALLU Finland Oy\r\nAll rights reserved.",
        termsOfService: "Terms of Service",
        contactInfo: {
            address: "Jokimäentie 1,\r\n16320 Pennala, FINLAND",
            phone: "Tel: ",
            fax: "Fax: +358 8 882 1440",
            email: "Email: ",
        },
        yes: "Yes",
        name: "Name",
        now: "Now",
        downloadFile: "Download file",
        save: "Save",
        new: "New",
        login: "Login",
        email: "Email",
        country: "Country",
        dealer: "Dealer",
        message: "Message",
        send: "Send",
        scrollIndicator: "Scroll down to read more",
        close: "Close"
    },
    error: {
        UNKNOWN_BLUETOOTH: "An unknown Bluetooth error has occurred. ({0}: {1})",
        TIMEOUT: "The operation timed out.",
        BLE_NOT_AVAILABLE: "This device does not support Bluetooth Low Energy, so Bluetooth features are unavailable.",
        BLE_NOT_ENABLED: "Bluetooth is disabled. Please enable Bluetooth in your mobile device's settings to use this feature.",
        PERMISSION_DENIED: "You denied the permission request, so this feature is unavailable.",
        DEVICE_NOT_FOUND: "Couldn't find product. Make sure the product is within Bluetooth range and try again.",
        CONNECTION_FAILED: "Failed to connect via Bluetooth.",
        INTERNET_CONNECTION_ERROR: "Failed to connect to the server. Please try again later.",
    },
    language: {
        cs: "Czech",
        de: "German",
        ee: "Estonian",
        en: "English",
        es: "Spanish",
        fi: "Finnish",
        fr: "French",
        hu: "Hungarian",
        it: "Italian",
        nl: "Dutch",
        no: "Norwegian",
        pl: "Polish",
        pt: "Portuguese",
        ru: "Russian",
        se: "Swedish",
        tr: "Turkish",
        zh: "Chinese",
    },
    startView: {
        title: "Home",
    },
    contactView: {
        title: "Contact ALLU",
        locateNearestDealer: "Locate nearest dealer",
        alluDistributors: "ALLU Distributors",
        nearestDealer: "Your nearest ALLU distributor",
        allDealers: "All ALLU dealers",
        enableGps: "Enable GPS",
        contactUs: "Contact us",
        validationError: "Please fill in all the fields.",
        sendSuccess: "Your message was sent. We will be in touch soon!",
        sendError: "Failed to send the message. Please ensure you're connected to the Internet.",
        locateNearestDealerFailed: "Couldn't locate nearest dealer",
    },
    addDevice: {
        typeSerialNumber: "Type serial number",
        add: "Add",
        showDevice: "Show device",
        errorSerialRequired: "Enter a serial number.",
        errorSerialExists: "You have already added this device. View it now?",
        errorSerialNotFound: "Serial number not found.",
        nearby: "Nearby",
        nearbyInfo: "Search for nearby ALLU products with Bluetooth.",
        searchForNearbyDevices: "Search for devices",
        searching: "Searching",
        noNearbyDevices: "No devices found",
    },
    addDeviceView: {
        title: "Search by serial number",
    },
    deviceApplicationsView: {
        title: "Applications",
    },
    deviceView: {
        specifications: "Specifications",
        documents: "Documents",
        applications: "Applications",
        options: "Options",
        removeDevice: "Remove from My Devices",
        errorRenamingUserDevice: "Error renaming device. Please try again or contact administration",
        confirmRemoveDevice: "Are you sure you want to remove this device from My Devices?",
        renameHelp: "Enter a new name for your device:",
        errorRemovingUserDevice: "There was an error removing the device. Please try again or contact administration."
    },
    deviceApplicationView: {
        noApplications: "Application media hasn't been added yet. Stay tuned!",
    },
    deviceStartView: {
        registerDevice: "Register device",
        limitedAccess: "You have not registered this device, limited information available",
        pending: "You request to access this device is pending.",
        pendingDeviceTitle: "PENDING DEVICE REQUESTS",
        deny: "Deny",
        allow: "Allow"
    },
    deviceListView: {
        title: "My Allu",
        noDevices: "You haven't added any devices yet. Add one to get started!",
        //noDevices: "Login to view registered products",
        addDevice: "Add product with serial number",
        deviceRemoved: "One or more devices were removed from the list because they no longer exist.",
        nearby: "NEARBY",
        searchDevices: "Search for nearby ALLU products. Make sure you have bluetooth enabled.",
        search: "SEARCH",
        registerToView: "Register to view details",
        pendingRequests: "pending requests",
        loadingDevices: "Loading devices"
    },
    deviceSpecificationsView: {
        title: "Specifications",
        wheelLoaderWeight: "Recommended Wheel loader weight range",
        excavatorWeight: "Recommended excavator weight range",
        partsList: "Parts list",
        part: "Part",
        partNumber: "Part number",
        limitedInformationAvailable: "This device has limited information available",
        limitedAccess: "You must register this device to view full information",
        pcs: "Pcs",
        showAllParts: "Show all parts"
    },
    deviceServiceOperationsView: {
        title: "Service operations"
    },
    deviceTroubleshootingView: {
        title: "Troubleshooting"
    },
    deviceLocationView: {
        title: "Location",
        date: "Date",
        service: "Service",
        sensor: "Operation Data",
        locationNotAvailable: "Last location is not available.",
        previous: "Previous",
        next: "Next",
        none: "None"
    },
    deviceDocumentView: {
        mustReadWarning: "Please read this document completely before continuing.",
        doneReading: "Done reading",
    },
    deviceInfo: {
        serial: "Serial",
        name: "Name",
        bucket: "Frame",
        drum: "Drum",
        isProject: "Customized product",
        weight: "Weight (without accessories)",
        width: "Width",
        height: "Height",
        lenght: "Lenght",
        maxPressure: "Pressure max",
        maxFlow: "Flow max",
        minFlow: "Flow min"
    },
    deviceRuntimeReports: {
        title: "Runtime reports",
        chooseCharts: "Choose charts",
        cumulativeUsage: "Cumulative usage",
        usagePerDay: "Usage per day",
        usagePerDayAverage: "Usage per day average",
        usagePerWeek: "Usage per week",
        usagePerMonth: "Usage per month",
        batteryLevelPerDay: "Battery level per day",
        temperaturePerWeek: "Temperature ",
        assetByCalender: "Asset by calender ",
        assetByWorkTime: "Asset by worktime system ",
        legendTimeDay: "Time [day]",
        legendTimeDayOfWeek: "Time [day of week]",
        legendTimeWeek: "Time [week]",
        legendTimeMonth: "Time [month]",
        legendRuntimeHour: "Runtime [hours]",
        legendRuntimePercent: "Runtime [%]",
        changeFilters: "Change filters",
        legendTemperatureWeek: "Temperature [°C]",
        legendBatteryLevel: "Level [%]",
        statisticsTitle: "Best",
        colTime: "Time",
        colRuntime: "Runtime",
        colAverage: "Average",
        rowMonth: "Month",
        rowWeek: "Week",
        rowDay: "Day",
        searching: "Searching...",
        noData: "No runtime data available."
    },
    deviceDocumentationView: {
        title: "Documentation"
    },
    deviceMaintenance: {
        title: "Service & Maintenance",
        sendServiceData: "Send service data",
        viewServiceRecord: "View service record",
        setupServiceParameters: "Setup service parameters",
        showTransformerLocation: "Show transformer location",
        specification: "Specification",
        partsList: "Parts list",
        troubleshooting: "Troubleshooting",
        warrantyInfo: "Warranty info",
        serviceBladeChange: "Blade",
        serviceGreasing: "Greasing",
        serviceChainDriveChange: "Chain drive",
        serviceMotorChange: "Motor",
        serviceCounterBladeChange: "Counter blade",
    },
    deviceSendServiceDataView: {
        title: "Send service data",
        chooseService: "Choose service",
        sent: "Service data has been sent",
        addComment: "Add comment (optional)",
        errorSendingData: "Error sending data. Please try again later",
        checked: "Checked",
        changed: "Changed",
        runtime: "Runtime",
        limitedFeaturesAvailable: "This device has limited features available"
    },
    deviceViewServiceRecordView: {
        title: "Service record",
        runtime: "Runtime",
        lastService: "Last service",
        nextService: "Est. next service",
        hoursUntilNextService: "Hours until next service",
        noData: "No service data available.",
        searching: "Searching..."
    },
    deviceSetupServiceParametersView: {
        title: "Set service intervals",
        saved: "Service intervals have been saved",
        runtime: "Runtime",
        resetFactoryDefaults: "Reset to factory defaults",
        limitedFeaturesAvailable: "This device has limited features available"
    },
    transformerLocationView: {
        title: "Transformer location"
    },
    deviceWarrantyInfoView: {
        title: "Warranty info",
        registrationStatus: "Registration status",
        registered: "Registered",
        unregistered: "Unregistered",
        validity: "Validity",
        validUntil: "Valid until",
        expiredOn: "Expired on",
        invalid: "Invalid"
    },
    partsListView: {
        title: "Parts list"
    },
    nearestDealerView: {
        title: "Nearest dealer",
    },
    loginView: {
        title: "Log in with ALLU ID",
        newUser: "New to ALLU ?",
        pin: "PIN",
        confirmWithPin: "We have sent you a PIN to your email. Please enter the 4 letter pin to log in",
        createAccount: "Create an account",
        errorEmail: "Invalid email",
        errorPin: "Invalid PIN"
    },
    safetyGuideView: {
        title: "Safety Guide",
    },
    transformerWorkingAngleView: {
        title: "Transformer working angle"
    },
    deviceOperatingDataView: {
        title: "Operating data"
    },
    deviceQuickGuidesView: {
        title: "Quick guides"
    },
    termsOfServiceView: {
        title: "Terms of Service"
    },
    registerDeviceView: {
        title: "Register device",
        chooseNewCompany: "Select another company",
        register: "Register",
        company: "Company",
        registerDevice: "Register device",
        registrationRequired: "You must login or register before registering this device",
        errorRegisteringDevice: "Error registering device. Please try again or contact administration",
        alreadyRegistered: "This device is already registered to another user. You must request access from the user to get full access of this device.",
        sendRequest: "SEND REQUEST",
        sended: "Request send successfully",
        sendFailed: "Failed to send request. Please try again later."
    },
    registerUserView: {
        title: "Register",
        givenName: "Given name",
        familyName: "Family name",
        email: "Email",
        company: "Company",
        register: "register",
        alreadyRegistered: "Email already registered.",
    },
    saveSensorLog: {
        save: "Save operation data",
        completed: "Operating data saved",
        lastSavedFormat: "Last saved: {0}",
        status: {
            scanning: "Looking for nearby product",
            connecting: "Connecting",
            connectingAttempt: "Connecting (attempt {0})",
            downloading: "Downloading data from sensor",
            uploading: "Sending data to server",
            completed: "Completed",
            error: "An error occurred.",
        },
    },
    inviteUserView: {
        title: "Invite User",
        email: "Email",
        button: "Invite",
        invited: "This email is not registered to any ALLU user yet. When email is registered this device will be added for the user.",
        alreadyAdded: "Device was already added for the user.",
        inviteexits: "Invitation for this device was already added to the email.",
        deviceAdded: "Device added to the user."
    }
};
